<template>
	<div :class="['step-two', {'mb-3': isActive && activeStep > 1}]">
		<stepHeader
			:msg="getDeliveryText"
			:currentStep="2"
			:maxStep="4"
			:useSubtitle="useSubtitle"
			:useBackgroundColor="useBackgroundColor"
		/>
		<div v-show="firstTimeDisplay && deliveryOption > 0 || isActive && activeStep > 1 && (selectedShippingMethodId || selectedStoreId)">
			<!-- Remove temporarily -->
			<!-- <div
				v-if="partialDeliveryAvailable && this.isActive"
				class="check-partial-delivery"
			>
				<checkbox
					v-model="pickedPartialDelivery"
					small
					label="Jag tar gärna emot flera separata leveranser om det gör att jag får produkterna snabbare."
				/>
				<hr />
			</div> -->

			<zipCodeSelector
				v-if="isActive && activeStep > 1"
				@updateZip="setZipCode"
				:zipCode="selectedZipCode"
				ref="zipSelector"
				:deliveryOption="deliveryOption"
				@setLocation="setLocation"
			/>

			<!-- Eol info -->
			<div
				v-if="shippingSiteInfo.hasEolProducts && isActive && hasEolDeliveryIssues['deliveryOption' + deliveryOption]"
				class="alert alert-danger eol-info"
			>
				<template v-for="eolInfo of stockAvailability.eolRelatedDeliveryIssues">
					<template v-if="eolInfo.deliveryOption === deliveryOption && eolInfo.products.length">
						<template v-if="eolInfo.translation === 'BULKY'">
							{{ te('BULKY_INFO') }}
							<hr>
						</template>
						{{ te(eolInfo.translation) }}
					</template>
					<ul
						v-if="eolInfo.deliveryOption === deliveryOption && eolInfo.products.length"
						class="eol-list"
					>
						<li
							v-for="product of eolInfo.products"
							class="eol-product"
						>
							<template v-if="deliveryOption === 2">
								{{ product }}
							</template>
							<template v-else>
								<b>{{ product }}:</b>
								<span v-for="store of shippingSiteInfo.eolStockPlaces[product] ">
									{{ storeName(store) }}
								</span>
							</template>
						</li>
					</ul>
				</template>
			</div>

			<checkoutStoreSelector
				v-if="deliveryOption === 1  && activeStep > 1"
				:cartRows="cart.rows"
				:stockMap="stockMap"
				:value="selectedStoreId"
				:isActive="isActive && activeStep > 1"
				:location="location"
				:selectedZipCode="selectedZipCode"
				:stepSelection.sync="stepSelection"
				:limitedByEol="shippingSiteInfo.hasEolProducts"
				:eolStockPlaces="shippingSiteInfo.eolStockPlaces"
				:eolProducts="stockAvailability.eolRelatedDeliveryIssues.specificStorePickup.products"
				@update:selectedStore="v => $emit('update:selectedStore', v)"
				@storeStock="setStoreStock"
			/>

			<div class="col-xs-12 ship-from-store" v-if="numberOfProductsSentFromStore > 0 && selectedZipCode && canShipNow && deliveryOption === 2 && isActive">
				<h3>Skickas direkt</h3>
				<p>Dina produkter skickas direkt från en butik.</p>
			</div>

			<loading-spinner v-if="deliveryOption === 2 && isActive && ! hasFetchedShippingMethods" />
			<template v-if="imiGoShippingMethods.length">
				<shippingMethod
					v-show="deliveryOption === 2 && parseInt(selectedZipCode) > 0 && ! changingZipCode && (isActive || selectedShippingMethodId) && activeStep > 1"
					class="list-group col-xs-12"
					:imiGoShippingMethods="imiGoShippingMethods"
					:shippingPriceMap="shippingPriceMap"
					:testConstraint="testConstraint"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:selectedShippingMethodId="selectedShippingMethodId"
					:selectedShippingOption="selectedShippingOption"
					:isActive="isActive && activeStep > 1"
					:activeStep="activeStep"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					:cart="cart"
					:user="user"
					:isCorporateCustomer="isCorporateCustomer"
					:mostExpensiveProductInCart="mostExpensiveProductInCart"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:isAllProductsSentFromStore="isAllProductsSentFromStore"
					:firstShippingMethod="true"
					:canShipNow="canShipNow"
					:stepSelection.sync="stepSelection"
					:isDownload="isDownload"
					:weight="weight"
					:volume="volume"
				/>

				<div class="col-xs-12 ship-from-store" v-if="numberOfProductsSentFromStore > 0 && selectedZipCode && canShipNow && deliveryOption === 2 && isActive && ! isCorporateCustomer">
					<h3>Skickas senare</h3>
					<p>Med dessa leveranssätt behöver vi vänta in dina produkter till vårt centrallager.</p>
				</div>
				<shippingMethod
					v-if="numberOfProductsSentFromStore > 0 && canShipNow"
					v-show="deliveryOption === 2 && parseInt(selectedZipCode) > 0 && ! changingZipCode && (isActive || selectedShippingMethodId) && activeStep > 1"
					class="list-group col-xs-12"
					:imiGoShippingMethods="imiGoShippingMethods"
					:shippingPriceMap="shippingPriceMap"
					:testConstraint="testConstraint"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:selectedShippingMethodId="selectedShippingMethodId"
					:selectedShippingOption="selectedShippingOption"
					:isActive="isActive && activeStep > 1"
					:activeStep="activeStep"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					:cart="cart"
					:user="user"
					:isCorporateCustomer="isCorporateCustomer"
					:mostExpensiveProductInCart="mostExpensiveProductInCart"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:isAllProductsSentFromStore="isAllProductsSentFromStore"
					:firstShippingMethod="false"
					:canShipNow="canShipNow"
					:stepSelection.sync="stepSelection"
					:weight="weight"
				/>
			</template>

			<text-button
				v-if="isActive"
				class="continue-btn"
				text="Fortsätt"
				:disabled="! showContinueButton"
				@click="finished"
			/>
		</div>
		<ship-from-store-popup
			v-if="showShipFromStorePopup && ! isCorporateCustomer"
			ref="shipFromStorePopup"
			@continue="finished"
			@changeToPostnord="changeToPostnord"
		/>
	</div>
</template>

<script>
import bus from 'eventbus';
import { debounce } from 'lodash';
import stepHeader from './step-header';
import checkoutStoreSelector from './checkout-store-selector';
import shippingMethod from './shipping-method';
import zipCodeSelector from './zip-code-selector';
import localSessionStorage from 'localSessionStorage';
import stockUtils from 'utils/stock';
import { daysBetweenDates } from 'utils';
import { getMostExpensiveProduct } from 'utils/cart';
import { mapState, mapGetters } from 'vuex';
import { storeName } from 'datastore/i18n';
import { t } from 'datastore/i18n';

export default {
	props: {
		stockMap: {},
		selectedShippingMethodId: {
			type: Number,
			required: false,
			default: 0,
		},
		selectedShippingOption: {},
		testConstraint: {
			type: Function,
		},
		updateOrderFlags: {
			type: Function,
		},
		isCorporateCustomer: {
			type: Boolean,
			required: true,
		},
		isActive: {
			type: Boolean,
			required: false,
		},
		activeStep: {
			type: Number,
		},
		predefinedCart: {
			type: Object,
			default: null,
		},
		orderTotalSum: {
			type: Number,
			default: null,
		},
		cartSum: {
			type: Number,
			default: null,
		},
		weight: {
			type: Number,
			default: null,
		},
		volume: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			changingZipCode: false,
			deliveryOption: 0,
			selectedZipCode: 0,
			location: {},
			selectedStoreId: null,
			firstTimeDisplay: false,
			pickedPartialDelivery: false,
			storeStock: null,
			stepSelection: '',
			imiGoShippingMethods: [],
			isDownload: false,
			hasFetchedShippingMethods: false,
		};
	},
	components: {
		stepHeader,
		zipCodeSelector,
		shippingMethod,
		checkoutStoreSelector,
	},
	beforeMount() {
		if (! this.splittableShippingOptions.length) {
			this.$store.dispatch('shippingMethodRelatedInfo/getShippingMethodRelatedInfo');
		}
	},
	mounted() {
		const isStoreReservation = localSessionStorage.get('checkout:isStoreReservation');
		this.setDeliveryOption(isStoreReservation ? 1 : 2);
		bus.$on('deliveryOptionChanged', this.setDeliveryOption);
		bus.$on('stepOneReverseComplete', this.startStepOne);
		bus.$on('selectedStoreChanged', this.setSelectedStore);
		bus.$on('update:zip', this.setZipCode);
		this.getShippingMethods();
	},
	beforeDestroy () {
		bus.$off('stepOneReverseComplete', this.startStepOne);
		bus.$off('deliveryOptionChanged', this.setDeliveryOption);
		bus.$off('selectedStoreChanged', this.setSelectedStore);
		bus.$off('update:zip', this.setZipCode);
	},
	methods: {
		storeName,
		t,
		te: t.prefix('EOL'),
		debouncedGetShippingMethods: debounce( function () {
			this.getShippingMethods();
		}, 333, { leading: false, trailing: true }),
		getShippingMethods () {
			this.hasFetchedShippingMethods = false;
			if (this.selectedZipCode) {
				const data = {
					postalCode: this.selectedZipCode,
					filters: {
						order_value: this.cartSum,
						order_weight: this.orderWeight,
						order_volume: this.orderVolume,
						is_bulky: this.isBulkyCart ? 'true' : 'false',
						customer_rank_level: this.user.rankLevel,
						has_digital_products: this.isDownload,
						is_corporate_customer: this.isCorporateCustomer,
						delivery_method: this.selectedShippingMethodId === 4 ? 'store' : 'ship',
						shipping_class: this.mostExpensiveProductInCart.shippingClass.id,
						shipping_site_id: this.shippingSiteInfo?.shippingSiteId,
						excluded_shipping_methods: "['" + this.excludedShippingMethods.join("','") + "']",
						max_length: this.maxLength.toString(),
						involves_ship_from_store: this.shippingSiteInfo.involvesShipFromStore
					}
				};

				waja.post('imi-go/shipping-methods')
					.data(data)
					.on('success', res => {
						this.imiGoShippingMethods = res.data;
						this.hasFetchedShippingMethods = true;
					}).go();
			}
		},
		finished (value) {
			if (this.numberOfProductsSentFromStore > 0 && ! this.isCorporateCustomer && ! this.splittableShippingOptions.includes(this.selectedShippingMethodId) && value != 'ship-later' && ! this.selectedStoreId) {
				if (! this.isDownload) {
					this.triggerShipFromStore();
					return;
				}
			}
			if (this.selectedStoreId) {
				bus.$emit('selectedStoreUpdated', this.selectedStoreId);
			} else {
				bus.$emit('selectedShippingMethodChanged', this.selectedShippingMethodId);
			}
			bus.$emit('stepUpdated', 3, this.selectedStoreId || this.selectedShippingMethodId);
		},
		setSelectedStore (store) {
			localSessionStorage.set('checkout:selectedStore', store);
			this.selectedStoreId = store;
		},
		setDeliveryOption (option) {
			this.deliveryOption = option;

			switch (option) {
				case 0:
					this.$emit('storeReservationUpdated', null);
					break;
				case 1: /* Store */
					this.setPartialDelivery();
					const store = localSessionStorage.get('checkout:selectedStore');
					if (store) {
						this.selectedStoreId = parseInt(store);
					}
					this.$emit('storeReservationUpdated', true);
					this.$emit('update:selectedShippingMethodId', 4);
					break;
				case 2: /* Delivery */
					this.$emit('stockAvailability', this.stockAvailability.inWebStock && ! this.stockAvailability.releaseDate);
					this.$emit('storeReservationUpdated', false);
					this.$emit('update:selectedShippingMethodId', null);
					break;
				default:
					break;
			}
		},
		setZipCode(zipCode) {
			this.selectedZipCode = parseInt(zipCode);
			this.getShippingMethods();
		},
		setLocation (location) {
			this.selectedStoreId = null;
			this.location = location;
			this.$nextTick(() => {
				bus.$emit('selectFirstStore', null);
			});
		},
		setPartialDelivery () {
			if (this.partialDeliveryAvailable) {
				this.$emit('partialDelivery', this.pickedPartialDelivery);
			} else {
				this.$emit('partialDelivery', false);
			}
		},
		setStoreStock (value) {
			this.storeStock = value;
		},
		triggerShipFromStore () {
			if (this.showShipFromStorePopup) {
				this.$refs.shipFromStorePopup.modalOpen = true;
			}
		},
		changeToPostnord () {
			this.$emit('update:selectedShippingMethodId', 1);
		},
		isStoreRestrictedByShippingSite(storeId) {
			return this.hasUnrestrictedShipping.indexOf(storeId ? storeId : this.reSupplyPointId) < 0;
		},
		isBulkyProduct (productSize) {
			return productSize > 2;
		},
		/**
		 * This method checks:
		 * if a product has any EOL places
		 * AND (no web stock
		 * OR web stock but only in store)
		 * @TODO move out qty check
		 */
		productCanOnlyShipFromStore (cartRow) {
			return this.shippingSiteInfo.eolStockPlaces?.[cartRow.product.id]
				&& (! this.shippingSiteInfo.eolStockPlaces?.[cartRow.product.id].includes('web')
				|| (this.shippingSiteInfo.eolStockPlaces?.[cartRow.product.id].includes('web')
				&& ! Object.keys(cartRow.product.stock.webStock).some(storeId => ! cartRow.product.stock.hasOwnProperty(storeId) && cartRow.product.stock.webStock[storeId] && cartRow.quantity <= cartRow.product.stock.webStock[storeId])));
		},
		isHeavy(weight) {
			return weight > 18;
		}
	},
	computed: {
		orderVolume () {
			let volume = 0;
			for (const row of this.cart.rows) {
				volume += Math.ceil(row.product.packageVolume / 1000000) * row.quantity;
			}
			return volume;
		},
		orderWeight () {
			let weight = 0;
			for (const row of this.cart.rows) {
				weight += (row.product.packageWeight); //we should check quantity here
			}
			return weight / 1000;
		},
		excludedShippingMethods () {
			const result = Object.keys(this.imiGoShippingMethodsMap).filter((methodId) =>
				this.fromStoreShipmentOptions && this.shippingSiteInfo.involvesShipFromStore && ! this.fromStoreShipmentOptions.includes(methodId * 1)
				|| ! this.testConstraint('shippingMethod', methodId * 1
			));

			const excluded = [];
			for (const res in result) {
				excluded.push(this.imiGoShippingMethodsMap[result[res]]);
			}

			for (const row of this.cart.rows) {
				if (row.product.meta.excluded_shipping_methods) {
					for (const method of Object.values(row.product.meta.excluded_shipping_methods)) {
						excluded.push(this.imiGoShippingMethodsMap[parseInt(method)])
					}
				}
			}
			if (this.packageMeasurement > 600) {
				excluded.push(this.imiGoShippingMethodsMap[31]);
			}

			if (this.packageMeasurement > 1400 || ! this.includeBoxes) {
				excluded.push(this.imiGoShippingMethodsMap[27]);
				excluded.push(this.imiGoShippingMethodsMap[28]);
				excluded.push(this.imiGoShippingMethodsMap[33]);
			}

			if (! this.includeAirmee) {
				excluded.push(this.imiGoShippingMethodsMap[26]);
			}

			return excluded;
		},
		isBulkyCart () {
			return this.cart.rows.some(row => this.isBulkyProduct(row.product.packageSizeId));
		},
		isAwkwardStoreShip () {
			return this.isBulkyCart || this.isHeavy(this.orderWeight) && ! this.isCorporateCustomer;
		},
		shippingSiteInfo () {
			let storeMap = {
				'hasStock': [...this.shippingStoresByPrioOrder], //Getting store ids for active warehouses
				// 'rows': {},
				'shippingSiteId': '',
				'isLimitedByShippingSite': true,
				'involvesShipFromStore': false,
				'hasEolProducts': false,
				'eolStockPlaces': {},
			};

			if (! (this.shippingStoresByPrioOrder && this.reSupplyPointId && this.horizonEnabled !== null)) {
				return {};
			}

			let split = {};
			let unstocked = false;
			this.cart.rows.forEach(row => {
				let storeId = null;
				if (row.product.stock.webStock) {
					for (let store of this.shippingStoresByPrioOrder) {
						let stock = row.product.stock.webStock[store];
						if (! stock || stock < row.quantity || (this.isCorporateCustomer && row.product.stock[store])) {
							storeMap.hasStock.splice(storeMap.hasStock.indexOf(store), 1); //excluding warehouses where orderrow not in stock
						} else if (! storeId && this.horizonEnabled) {
							storeId = store;
						}
					}
				} else if (row.product.stock.download) {
					storeMap.hasStock = [this.reSupplyPointId];
				}
				unstocked = unstocked || ! storeId ? true : false;
				storeId = storeId ? storeId : this.reSupplyPointId;
				split[storeId] = storeId;
				/**
				 * looks for discontinued products and creates object
				 * with store id arryas where the product is in stock
				 */
				if (row.product.discontinued) {
					storeMap.hasEolProducts = true;
					storeMap.eolStockPlaces[row.product.id] = Object.keys(row.product.stock).filter(( key ) => {
						return row.quantity <= row.product.stock[key] && key !== 'displayCap';
					});
				}
			});
			storeMap.shippingSiteId = (storeMap?.hasStock?.length ? storeMap.hasStock[0] : this.reSupplyPointId).toString();
			storeMap.isLimitedByShippingSite = this.isStoreRestrictedByShippingSite(storeMap.shippingSiteId * 1);

			if (! storeMap.hasStock.length && Object.keys(split).length > 1) {
				if (! storeMap.hasEolProducts && unstocked) {
					split = {[storeMap.shippingSiteId]: storeMap.shippingSiteId};
				} else {
					storeMap.isLimitedByShippingSite = true;
				}
			}

			let stockItems = this.cart.rows[0].product.stock;
			//if any of the chosen stores matches a object key outside of the webstock arrat, that means shipFromStore is an option
			storeMap.involvesShipFromStore = this.BulkyCart && ! storeMap.hasEolProducts ? false : Object.keys(split).some(itemId => stockItems[itemId] >= 0);

			return storeMap;
		},
		maxLength () {
			return Math.max(...this.cart.rows.map(row => row.product.largestMeasure), 0) / 10;
		},
		packageMeasurement () {
			let measurement = 0;
			for (const row of this.cart.rows) {
				const measure = row.product.packageMeasurements.reduce((acc, curr) => {
					return acc + curr
				});
				measurement += measure * row.quantity;
			}
			return measurement
		},
		includeBoxes () {
			for (const row of this.cart.rows) {
				const measurements = row.product.packageMeasurements;
				const max = Math.max(...measurements);
				const index = measurements.indexOf(max);
				if (index > -1) {
					measurements.splice(index, 1);
				}
				const includeBoxes = max <= 600 && measurements.every(num => num <= 400);
				if (! includeBoxes) {
					return false;
				}
			}
			return true;
		},
		includeAirmee () {
			let circumference = 0;
			for (const row of this.cart.rows) {
				circumference += row.product.packageCircumference * row.quantity;
			}
			if (circumference > 3000 || this.orderWeight > 25 || this.maxLength > 80) {
				return false;
			}
			return true;
		},
		/**
		 * The combined stock availability. Checks the stock for each product in
		 * the cart and combines the results.
		 *
		 * The product that has the least favorable stock conditions will determine
		 * the outcome of the stock availability for the entire cart.
		 *
		 * Each cart row will be iterated, and the following conditions checked:
		 *
		 * 1 Unreleased product => Estimated delivery time of order will be set to the release date
		 * of the product.
		 *
		 * 2 In web stock => Good!
		 *
		 * 3 Web stock due soon => One product will be in web stock soon, therefore
		 * set the estimated delivery time for the entire order to be the estimated
		 * number of days until delivery to CL is due for arrival.
		 *
		 * 4 Out of stock => One product is out of stock, therefore the entire
		 * order is out of stock.
		 */
		stockAvailability () {
			const now = new Date();
			/*
			* The result of merging the stock of each cart row will be stored in
			* this object.
			*/
			const availability = {
				inDigitalStock: undefined,
				// Will result in true/false depending on if CL stock is available.
				inWebStock: undefined,
				// May contain an estimate of number of days until stock is available.
				estimateDays: null,
				// May contain the release date of an unreleased product.
				releaseDate: null,
				// Info for orders with EOL products
				eolRelatedDeliveryIssues: {
					bulky: {
						translation: 'BULKY',
						deliveryOption: 2,
						products: [],
					},
					shipFromStore: {
						translation: 'SHIP_FROM_STORE',
						deliveryOption: 2,
						products: [],
					},
					cantShip: {
						translation: 'CANT_SHIP',
						deliveryOption: 2,
						products: [],
					},
					outOfStock: {
						translation: 'OUT_OF_STOCK',
						deliveryOption: 2,
						products: [],
					},
					specificStorePickup: {
						translation: 'SPECIFIC_STORE_PICKUP',
						deliveryOption: 1,
						products: [],
					},
				},
			};

			/**
			 * Previous returns in code stopped the for loop from
			 * checking every product in cart, so these makes sure
			 * the data is still correct while still checking
			 * all products for data needed for EOL
			 */
			let checkForLoopData = true;
			let checkStockMap = true;
			let checkElseIf = true;

			// If we have no stock map, then return default object.
			if (! Object.keys(this.stockMap).length) {
				checkForLoopData = false;
			}

			for (const row of this.cart.rows) {
				const releaseDate = new Date();
				releaseDate.setTime(row.product.release.timestamp * 1000);

				// EOL related checks
				if (this.shippingSiteInfo.hasEolProducts) {
					// Checks if product is in any web stock
					if (this.shippingSiteInfo.eolStockPlaces?.[row.product.id]
						&& ! this.shippingSiteInfo.eolStockPlaces?.[row.product.id].includes('web')) {
						availability.eolRelatedDeliveryIssues.cantShip.products.push(row.product.id);
					}

					if (this.isBulkyCart) {
						// Checks for bulky products since they can't be sent from store
						if (this.shippingSiteInfo.involvesShipFromStore && this.isBulkyProduct(row.product.packageSizeId)) {
							availability.eolRelatedDeliveryIssues.bulky.products.push(row.product.id);
						}

						if (this.productCanOnlyShipFromStore(row)) {
							availability.eolRelatedDeliveryIssues.shipFromStore.products.push(row.product.id);
						}
					}

					// We cant send corporate packages from store
					if (this.isCorporateCustomer && this.productCanOnlyShipFromStore(row)) {
						availability.eolRelatedDeliveryIssues.cantShip.products.push(row.product.id);
					}

					/**
					 * EOL products can't be sent to different stores so they can only
					 * be picked up in the store they're in
					 */
					if (this.productCanOnlyShipFromStore(row)) {
						availability.eolRelatedDeliveryIssues.specificStorePickup.products.push(row.product.id);
					}

					/**
					 * If a non EOL product is out of webstock, or is not released
					 * we can't send that product in the same order as the EOL product
					 */
					if (! row.product.stock.web || daysBetweenDates(releaseDate, now) > 0) {
						availability.eolRelatedDeliveryIssues.outOfStock.products.push(row.product.id);
					}
				}

				// Check if the product is yet to be released.
				if (daysBetweenDates(releaseDate, now) > 0) {
					if (! availability.releaseDate || (availability.releaseDate && releaseDate > availability.releaseDate)) {
						availability.releaseDate = releaseDate;
						availability.inWebStock = false;
					}
					continue;
				}

				if (checkForLoopData && checkStockMap && checkElseIf) {
					const qty = row.quantity;
					const prodId = row.product.id + '';
					const stockMap = this.stockMap[prodId];

					if (! stockMap) {
						// Entry for product in stock map is missing, so the result
						// is that the cart products are not all in stock.
						availability.inWebStock = false;
						availability.inDigitalStock = false;
						// Don't display a release date (for when products can be delivered).
						availability.releaseDate = null;
						checkStockMap = false;
					}
					// Set if gift card or not
					this.isDownload = stockMap['download'] > 0;
					// Special logic for digital downloads.
					if (this.selectedShippingMethodId === 5) {
						availability.inDigitalStock = stockMap['download'] > 0;
					}

					const deliveryInfo = stockUtils.timeToWebStockDelivery(stockMap);
					let days = null;
					// Estimated number of days until product is in stock at CL.
					if (deliveryInfo && deliveryInfo.days) {
						days = deliveryInfo.days;
					}

					const shipFromStore = [];
					for (const store in stockMap) {
						if (! isNaN(store) && parseInt(Number(store)) == store && ! isNaN(parseInt(store, 10))) {
							shipFromStore.push(parseInt(store))
						}
						availability.shipFromStore = shipFromStore;
						const storeId = store + '';
						const inStockInStore = stockMap[storeId] >= qty;
						availability.inStockInStore = inStockInStore;
						if (storeId === 'web' && inStockInStore && availability.inWebStock === undefined) {
							// Product is in stock and availability has not been set yet.
							availability.inWebStock = true;
						} else if (storeId === 'web' && !inStockInStore && days) {
							// We have an estimated number of days when the product
							// will be in stock in CL.
							availability.inWebStock = false;
							if (!availability.estimateDays) {
								// Initialize the estimate days array.
								availability.estimateDays = [0, 0];
							}
							// Update estimate (the product with the longest esitmated
							// delivery time will determine the estimate).
							if (days[0] > availability.estimateDays[0]) {
								availability.estimateDays[0] = days[0];
							}
							if (days[1] > availability.estimateDays[1]) {
								availability.estimateDays[1] = days[1];
							}
						} else if (storeId === 'web' && ! inStockInStore && ! days) {
							// Not in web stock!
							availability.inWebStock = false;
							availability.estimateDays = null;
							// Don't display a release date (for when products can be delivered).
							availability.releaseDate = null;
							checkElseIf = false;
						}
					}
				}
			}

			return availability;
		},
		shippingPriceMap () {
			const mostExpensiveProduct = this.mostExpensiveProductInCart;

			const map = {};
			if (! mostExpensiveProduct) return map;
			for (const pr of mostExpensiveProduct.shippingClass.prices) {
				let newPrice = pr.price;
				let discountedPrice = (! pr.isFixedPrice && (this.rankLevel > 0 || this.cartSum >= 500)) || (this.rankLevel > 0 && this.cartSum >= 500);

				if (discountedPrice && pr.shippingMethodId !== 2) {
					if (this.rankLevel > 0 && this.cartSum >= 500 && (pr.shippingMethodId == 25 || pr.shippingMethodId == 29 || ((mostExpensiveProduct.shippingClass.id == 1 || mostExpensiveProduct.shippingClass.id == 2 || mostExpensiveProduct.shippingClass.id == 3 || mostExpensiveProduct.shippingClass.id == 4) && (pr.shippingMethodId == 3 || pr.shippingMethodId == 26)))) {
						if (this.rankLevel <= 8) newPrice = 49;
						else if (this.rankLevel <= 16) newPrice = 39;
						else if (this.rankLevel <= 24) newPrice = 29;
						else newPrice = 0;
					} else if (this.rankLevel > 0 && this.cartSum >= 500 && (pr.shippingMethodId == 3 || pr.shippingMethodId == 26)) {
						if (this.rankLevel <= 8) newPrice = 299;
						else if (this.rankLevel <= 16) newPrice = 199;
						else if (this.rankLevel <= 24) newPrice = 99;
						else newPrice = 0;
					} else if (pr.shippingMethodId !== 2) {
						newPrice = 0;
					}
				}

				if (pr.shippingMethodId == 26 && this.rankLevel > 0 && newPrice > 0) {
					newPrice = newPrice - 10;
				}

				if (mostExpensiveProduct.shippingClass.id == 22 && pr.shippingMethodId == 3) {
					newPrice = 0;
				}

				map[pr.shippingMethodId + ''] = newPrice;
			}
			return map;
		},
		cart () {
			if (this.predefinedCart) {
				return this.predefinedCart;
			}
			return this.$store.state.cart;
		},
		mostExpensiveProductInCart () {
			return getMostExpensiveProduct(this.cart);
		},
		hasEolDeliveryIssues () {
			let options = {
				deliveryOption1: false,
				deliveryOption2: false,
			}

			if (this.stockAvailability.eolRelatedDeliveryIssues.bulky.products.length
				|| this.stockAvailability.eolRelatedDeliveryIssues.shipFromStore.products.length
				|| this.stockAvailability.eolRelatedDeliveryIssues.cantShip.products.length
				|| this.stockAvailability.eolRelatedDeliveryIssues.outOfStock.products.length
			) {
				options.deliveryOption2 = true;
			}

			if (this.stockAvailability.eolRelatedDeliveryIssues.specificStorePickup.products.length) {
				options.deliveryOption1 = true;
			}

			return options;
		},
		...mapGetters({
			/*shippingDiscount: 'user/shippingDiscount',*/
			isLoggedIn: 'user/isLoggedIn',
			rankLevel: 'user/rankLevel',
		}),
		...mapState({
			user: state => state.user,
			imiGoShippingMethodsMap: state => state.shippingMethodRelatedInfo.imiGoShippingMethodsMap,
			splittableShippingOptions: state => state.shippingMethodRelatedInfo.splittableShippingOptions,
			fromStoreShipmentOptions: state => state.shippingMethodRelatedInfo.fromStoreShipmentOptions,
			shippingStoresByPrioOrder: state => state.shippingMethodRelatedInfo.shippingStoresByPrioOrder,
			hasUnrestrictedShipping: state => state.shippingMethodRelatedInfo.hasUnrestrictedShipping,
			reSupplyPointId: state => state.shippingMethodRelatedInfo.reSupplyPointId,
			horizonEnabled: state => state.shippingMethodRelatedInfo.horizonEnabled,
			eolFromStoreShipmentEnabled: state => state.shippingMethodRelatedInfo.eolFromStoreShipmentEnabled,
		}),
		getDeliveryText () {
			if (this.deliveryOption === 1) {
				return 'Välj Butik';
			} else if (this.deliveryOption === 2) {
				return 'Välj Fraktsätt';
			} else {
				return 'Välj Butik/fraktsätt';
			}
		},
		useSubtitle () {
			if (this.deliveryOption === 0 || ! this.isActive) {
				return true;
			} else {
				return false;
			}
		},
		useBackgroundColor () {
			if (! this.firstTimeDisplay || ! this.isActive && this.deliveryOption < 1 || ! this.isActive && (this.selectedShippingMethodId < 1 && this.selectedStoreId < 1) || this.activeStep < 2) {
				return true;
			} else {
				return false;
			}
		},
		showContinueButton () {
			if (this.isActive) {
				if (this.deliveryOption === 1 && this.selectedStoreId) {
					if (this.stockAvailability.eolRelatedDeliveryIssues.specificStorePickup.products.length) {
						let canContinue = true;
						this.stockAvailability.eolRelatedDeliveryIssues.specificStorePickup.products.forEach((product) => {
							if (! this.shippingSiteInfo.eolStockPlaces[product].includes(this.selectedStoreId.toString())) {
								canContinue = false;
							}
						});
						return canContinue;
					} else {
						return true;
					}
				} else if (this.deliveryOption === 2 && this.selectedShippingMethodId && this.selectedZipCode ) {
					return ! this.hasEolDeliveryIssues.deliveryOption2;
				}
			}
			return false;
		},
		partialDeliveryAvailable () {
			return this.deliveryOption !== 1 && this.activeStep > 1 && ! this.stockAvailability.inWebStock && this.cart.rows.length > 1 && this.orderTotalSum >= 598;
		},
		numberOfProductsSentFromStore () {
			return this.cart.rows.reduce((acc, curr) => acc + (curr.product.stock.isSentFromStore !== 0 || 0), 0);
		},
		isAllProductsSentFromStore () {
			return this.numberOfProductsSentFromStore === this.cart.rows.length ? true : false;
		},
		canShipNow () {
			if (this.numberOfProductsSentFromStore > 0 && this.stockAvailability?.shipFromStore?.length) {
				for (const store of this.stockAvailability.shipFromStore) {
					const allExistsInSameStore =  this.cart.rows.every((curr) => {
						const quantity = curr.quantity;
						const stock = curr.product.stock[store];

						return stock >= quantity;
					});
					if (allExistsInSameStore) {
						return true;
					}
				}
				return false;
			}
			return this.stockAvailability.inWebStock;
		},
		showShipFromStorePopup () {
			return this.numberOfProductsSentFromStore > 0 && ! this.isDownload && this.stockAvailability.inStockInStore;
		}
	},
	watch: {
		cart: {
			handler (to, frm) {
				this.debouncedGetShippingMethods();
			},
			deep: true,
		},
		selectedZipCode (to, frm) {
			if (to !== frm && frm !== 0) {
				this.selectedStoreId = null;
			}
		},
		isActive (to, frm) {
			if (to) {
				this.firstTimeDisplay = true;
			}
		},
		activeStep (to) {
			if (to === 1) {
				this.deliveryOption = 0;
				this.$emit('storeReservationUpdated', null);
			}
		},
		pickedPartialDelivery () {
			this.setPartialDelivery();
		},
		partialDeliveryAvailable (to, frm) {
			if (this.isActive) {
				this.setPartialDelivery();
			}
		},
		/* Watches store change */
		storeStock (to) {
			if (this.deliveryOption === 1) {
				this.$emit('stockAvailability', !! to || (this.stockAvailability.inWebStock && ! this.stockAvailability.releaseDate));
			}
		},
		/* Watches the stock change, depending on changes to quantity in cart */
		stockAvailability (to) {
			if (this.deliveryOption === 2) { // Delivery
				this.$emit('stockAvailability', to.inWebStock && ! to.releaseDate);
			} else if (this.deliveryOption === 1) { // Store
				this.$emit('stockAvailability', !! this.storeStock || (to.inWebStock && ! to.releaseDate));
			}
		},
		stepSelection (to) {
			if (to) {
				this.$emit('stepSelection', { 2: to });
			}
		},
		isCorporateCustomer (to, frm) {
			if (to !== frm) {
				this.imiGoShippingMethods = [];
			}
		},
		shippingSiteInfo (to) {
			localSessionStorage.set('checkout:shippingSiteId', to.shippingSiteId);
			this.$emit('update:shippingSiteInfo', to);
		},
	},
};
</script>
